import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "/v1/stories";

export default {
  /**
   * Hikaye listesini getirir.
   *
   * @param {Object} params - Sorgu parametreleri
   * @param {number} params.Page - Sayfa numarası
   * @param {number} params.PageSize - Sayfa başına eleman sayısı
   * @returns {Promise} Axios isteği sonucu dönen promise
   */
  getStories(params) {
    return axios.get(`${RESOURCE_NAME}`, { params });
  },

  /**
   * Yeni bir hikaye ekler.
   *
   * @param {Object} body - Hikaye verisi
   * @param {string} body.Image
   * @param {string} body.Thumbnail
   * @param {string} body.ExpireDate
   * @param {string} body.SectionLink
   * @param {number} body.ContentId
   * @param {boolean} body.IsTest
   * @returns {Promise} Axios isteği sonucu dönen promise
   */
  createStory(body) {
    return axios.post(`${RESOURCE_NAME}`, body);
  },

  /**
   * Belirtilen ID'li hikayeyi günceller.
   *
   * @param {Object} body - Güncellenmiş hikaye verisi
   * @param {number} body.Id
   * @param {string} body.Title
   * @param {string} body.Image
   * @param {string} body.Thumbnail
   * @param {string} body.ExpireDate
   * @param {string} body.SectionLink
   * @param {number} body.ContentId
   * @param {boolean} body.IsTest
   * @returns {Promise} Axios isteği sonucu dönen promise
   */
  updateStory(body) {
    const { Id, ...others } = body;

    return axios.put(`${RESOURCE_NAME}/${Id}`, others);
  },

  /**
   * Belirtilen ID'li hikayeyi getirir.
   *
   * @param {number|string} id - Hikaye ID'si
   * @returns {Promise} Axios isteği sonucu dönen promise
   */
  getStoryById(id) {
    return axios.get(`${RESOURCE_NAME}/${id}`);
  },

  /**
   * Belirtilen ID'li hikayeyi siler.
   *
   * @param {number|string} id - Silinecek hikaye ID'si
   * @returns {Promise} Axios isteği sonucu dönen promise
   */
  deleteStory(id) {
    return axios.delete(`${RESOURCE_NAME}/${id}`);
  },
};
